import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MessagesComponent } from './messages/messages.component';
import { RegulationComponent } from './regulation/regulation.component';
import { ShowFileComponent } from './file/show-file/show-file.component';

const routes: Routes = [
  { path: 'message', component: MessagesComponent},
  { path: 'reglamento', component: RegulationComponent},
  { path: 'archivos', component: ShowFileComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
